<!--
  文件描述：无缝滚动组件
-->
<template>
  <div class="">
    <div class="page-example3" style="">
      <vue-seamless-scroll :data="listData" :class-option="defaultOption">
        <ul class="ul-scoll">
          <li v-for="(item, index) in listData" :key="index">
            <div>
              <span><img src="@/assets/images/li-1.png" alt="" /></span
              ><span>来自杭州市166****2683的用户已领取！</span>
            </div>
            <div>
              <span><img src="@/assets/images/li-2.png" alt="" /></span
              ><span>来自沧州市159****3287的用户已领取！</span>
            </div>
            <div>
              <span><img src="@/assets/images/li-3.png" alt="" /></span
              ><span>来自镇江市139****2703的用户已领取！</span>
            </div>
            <div>
              <span><img src="@/assets/images/li-4.png" alt="" /></span
              ><span>来自新乡市180****2590的用户已领取！</span>
            </div>
            <div>
              <span><img src="@/assets/images/li-5.png" alt="" /></span
              ><span>来自太原市189****3309的用户已领取！</span>
            </div>
            <div>
              <span><img src="@/assets/images/li-6.png" alt="" /></span
              ><span>来自安顺市158****0075的用户已领取！</span>
            </div>
            <div>
              <span><img src="@/assets/images/li-7.png" alt="" /></span
              ><span>来自合肥市181****3380的用户已领取！</span>
            </div>
            <div>
              <span><img src="@/assets/images/li-8.png" alt="" /></span
              ><span>来自临沂市156****0269的用户已领取！</span>
            </div>
            <div>
              <span><img src="@/assets/images/li-9.png" alt="" /></span
              ><span>来自长沙市132****0269的用户已领取！</span>
            </div>
          </li>
        </ul>
      </vue-seamless-scroll>
    </div>
  </div>
</template>

<script>
import vueSeamlessScroll from "vue-seamless-scroll";
export default {
  name: "Example3",
  components: {
    vueSeamlessScroll,
  },
  data() {
    // 这里存放数据
    return {
      listData: [],
    };
  },
  // 监听属性 类似于data概念
  computed: {
    defaultOption() {
      return {
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: false, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
  // 方法集合
  methods: {},
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    for (let i = 0; i < 10; i++) {
      let j = {
        // title:'来自' + '杭州市' + '166****0726 ' + '的用户已领取' ,
        time: i,
      };
      this.listData.push(j);
    }
  },
};
</script>

<style scoped lang="scss">
//@import url(); 引入公共css类
.page-example3 {
  width: 100%;
  height: 2rem;
  // overflow: hidden;
  // border: 1px solid #283dff;
  .ul-scoll {
    li {
      // background: rgba(198, 142, 226, 0.4);
      list-style: none;
      //border: 1px solid #000;
      span {
        margin-left: 5px;
      }
    }
    img {
      display: inline-block;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      vertical-align: middle;
    }
  }
}
</style>
